import { Box, CircularProgress, Typography } from "@mui/material";
import { Fragment, useState } from "react";
import { HtmlTooltip } from "../styled-components/HtmlTooltip";
import { fetchFromApi } from "../helpers/fetchFromApi";
import { aggregateFixtureMarketOdds } from "../helpers/fixtureMarketOdds";


/*
 * Ein Fixture = ein Sportmonks-Odds-Abruf.
 *
 * Die komplette 1X2-Gruppe wird gemeinsam ausgewertet.
 * Dadurch brauchen Liga-Arbeitsliste und OddsTooltip
 * NICHT je Ergebnis einen eigenen Request.
 */
const fixtureOddsCache =
  new Map();

const fixtureOddsPromiseCache =
  new Map();


async function fetchFixtureOddsRecords(
  oddsId
) {
  const cacheKey =
    String(oddsId);

  if (
    fixtureOddsCache.has(
      cacheKey
    )
  ) {
    return fixtureOddsCache.get(
      cacheKey
    );
  }

  if (
    fixtureOddsPromiseCache.has(
      cacheKey
    )
  ) {
    return fixtureOddsPromiseCache.get(
      cacheKey
    );
  }

  const requestPromise =
    (async () => {
      const response =
        await (
          await fetchFromApi(
            `fetch-data-v3/odds/pre-match/fixtures/${oddsId}`
          )
        ).json();

      const source =
        Array.isArray(
          response?.data
        )
          ? response.data
          : [];

      fixtureOddsCache.set(
        cacheKey,
        source
      );

      return source;
    })();

  fixtureOddsPromiseCache.set(
    cacheKey,
    requestPromise
  );

  try {
    return await requestPromise;
  } finally {
    fixtureOddsPromiseCache.delete(
      cacheKey
    );
  }
}

export async function fetchFixtureMarketOdds(
  oddsId,
  market,
  options
) {
  return aggregateFixtureMarketOdds(
    await fetchFixtureOddsRecords(
      oddsId
    ),
    market,
    options
  );
}

export async function fetchMatchWinnerOdds(
  oddsId
) {
  return (
    await fetchFixtureMarketOdds(
      oddsId,
      "1x2"
    )
  )?.outcomes || {};
}


export function OddsTooltip({ oddsId, label, children }) {
  const [highest, setHighest] = useState(false);
  const [average, setAverage] = useState(false);

  async function loadOdds() {
    setHighest(false);
    setAverage(false);

    try {
      const odds =
        await fetchMatchWinnerOdds(
          oddsId
        );

      const selected =
        odds?.[label];

      if (
        !selected ||
        !Number.isFinite(
          selected.highest
        ) ||
        !Number.isFinite(
          selected.average
        )
      ) {
        setHighest("-");
        setAverage("-");
        return;
      }

      setHighest(
        selected.highest.toFixed(
          3
        )
      );

      setAverage(
        selected.average.toFixed(
          3
        )
      );
    } catch (error) {
      console.error(
        "Could not load v3 pre-match odds:",
        oddsId,
        error
      );

      setHighest("-");
      setAverage("-");
    }
  }

  return (
    <div>
      <HtmlTooltip
        onOpen={loadOdds}
        title={
          <Fragment>
            <Box
              display={highest || average ? "none" : "inline-block"}
              style={{
                margin: "auto",
                position: "relative",
                left: "50%",
                transform: "translateX(-50%)",
                height: "10px",
              }}
            >
              <CircularProgress size={20} />
            </Box>

            <Typography display={highest ? "block" : "none"}>
              highest: {highest}
            </Typography>

            <Typography display={average ? "block" : "none"}>
              average: {average}
            </Typography>
          </Fragment>
        }
      >
        {children}
      </HtmlTooltip>
    </div>
  );
}
